import "../App.css";
// Import the images
import tesla from "../images/tesla.png";
import civic from "../images/civic.png";
import wrx from "../images/wrx.png";
import porsche911 from "../images/porsche911.png";
import porscheGT3 from "../images/porscheGT3.png";
import explorer from "../images/image-by-path.png";
import tahoe from "../images/2024-chevrolet-tahoe-lt-suv-angular-front.png";
import astonmartin from "../images/2023-aston-martin-db11-coupe-angular-front.png";
import stelvio from "../images/2023-alfa-romeo-stelvio-ti-4wd-suv-angular-front.png";
import chrysler from "../images/2017-chrysler-200-limited-platinum-sedan-angular-front.png";
import bmwm4 from "../images/00f6e092-42df-4d3e-8004-6e62980466e6.png";
import instagramIcon from "../images/instagram.png";
import tiktokIcon from "../images/tiktok.png";
import ram from "../images/ram.png";
import rolla from "../images/rolla.png";
import nextdoorIcon from "../images/nextdoor.png";
import { useState, useEffect } from "react";

function Packages({ setShowPackages, setSelectedPackage }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [animationSpeed, setAnimationSpeed] = useState(30); // Default speed in seconds

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSpeedChange = (event) => {
    setAnimationSpeed(event.target.value);
  };

  const styles = {
    app: {
      fontFamily: '"Space Grotesk", sans-serif',
      lineHeight: 1.6,
      backgroundColor: "#0a0b0e",
      color: "#ffffff",
      position: "relative",
      overflowX: "hidden",
      overflowY: "auto",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
    },
    desktopBackButton: {
      position: "fixed",
      top: "1.2rem",
      left: "2rem",
      padding: "0.75rem 1.5rem",
      fontSize: "1rem",
      background: "rgba(88, 101, 242, 0.1)",
      border: "1px solid rgba(88, 101, 242, 0.5)",
      borderRadius: "8px",
      color: "#ffffff",
      cursor: "pointer",
      transition: "all 0.3s ease",
      zIndex: 1001,
      fontFamily: '"Space Grotesk", sans-serif',
      letterSpacing: "1px",
      backdropFilter: "blur(8px)",
      transform: "none",
    },
    mobileBackButton: {
      padding: "0.4rem 0.8rem",
      fontSize: "0.9rem",
      background: "rgba(88, 101, 242, 0.2)",
      border: "1px solid rgba(88, 101, 242, 0.5)",
      borderRadius: "8px",
      color: "#ffffff",
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "auto",
      height: "35px",
      marginTop: "-5px",
      lineHeight: 1,
      whiteSpace: "nowrap",
    },
    backIcon: {
      fontSize: "1.2rem",
    },
    packagesHeader: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "80px",
      background: "rgba(20, 23, 31, 0.95)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderBottom: "1px solid rgba(88, 101, 242, 0.2)",
      zIndex: 1000,
      padding: "0 2rem",
    },
    headerContent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      position: "relative",
      padding: "10px 20px",
    },
    titlePart: {
      fontSize: "2.5rem",
      fontWeight: 800,
      color: "#ffffff",
      textShadow: "0 0 20px rgba(88, 101, 242, 0.5)",
      letterSpacing: "2px",
      textTransform: "uppercase",
      background: "linear-gradient(45deg, #fff, #5865f2)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      filter: "drop-shadow(0 0 10px rgba(88, 101, 242, 0.3))",
    },
    socialIcons: {
      position: "absolute",
      top: "55%",
      right: "var(--social-icons-right)",
      transform: "translateY(-50%)",
      display: "flex",
      gap: "10px",
    },
    socialIcon: {
      width: "35px",
      height: "35px",
    },
    nextdoorSocialIcon: {
      width: "58px",
      height: "32px",
      marginLeft: "-13px",
      marginTop: "2px",
    },
    hero: {
      flex: 1,
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
      paddingTop: isMobile ? "1rem" : "80px",
    },
    packagesGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(5, 1fr)",
      gap: isMobile ? "1.5rem" : "1rem",
      width: "100%",
      maxWidth: "1800px",
      position: "relative",
      zIndex: 1,
      padding: isMobile ? "0.5rem 1rem" : "0 1rem",
      margin: "0 auto",
      overflowX: "hidden",
    },
    packageCard: {
      position: "relative",
      width: "100%",
      paddingTop: "100%",
      display: "block",
    },
    packageContent: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      cursor: "pointer",
      backgroundSize: "cover",
      backgroundPosition: "center",
      border: "1px solid rgba(88, 101, 242, 0.2)",
      borderRadius: "16px",
      padding: "1rem",
    },
    exteriorPackage: {
      backgroundImage: 'url("../images/new-exterior-background.png")',
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: "white",
      padding: "10px 20px",
      border: "none",
      textAlign: "center",
    },
    packageHeader: {
      border: "none",
      marginBottom: 0,
      textAlign: "center",
      width: "100%",
    },
    packageTitle: {
      color: "white",
      fontWeight: "bold",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      margin: "0px",
      padding: "0px",
      fontSize: isMobile ? "24px" : "27px",
      textAlign: "center",
      display: "block",
      lineHeight: isMobile ? "1.2" : "normal",
      marginBottom: "0.5rem",
    },
    price: {
      marginTop: isMobile ? "0.5rem" : "0.75rem",
      padding: 0,
      color: "rgba(255, 255, 255, 0.774)",
      fontWeight: "normal",
      background: "none",
      border: "none",
      boxShadow: "none",
      fontSize: isMobile ? "1.1rem" : "1rem",
      width: "100%",
      textAlign: "center",
    },
    mobileHeader: {
      background: "rgba(20, 23, 31, 0.95)",
      backdropFilter: "blur(8px)",
      borderBottom: "1px solid rgba(88, 101, 242, 0.2)",
      padding: "0.5rem",
      width: "100%",
    },
    mobileHeaderContent: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.4rem",
      padding: "0.5rem",
    },
    mobileTitlePart: {
      fontSize: "1.8rem",
      fontWeight: 800,
      color: "#ffffff",
      textShadow: "0 0 20px rgba(88, 101, 242, 0.5)",
      letterSpacing: "2px",
      textTransform: "uppercase",
      background: "linear-gradient(45deg, #fff, #5865f2)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      textAlign: "center",
      lineHeight: 1.2,
    },
    mobileSocialIcons: {
      display: "flex",
      gap: "1rem",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "0.3rem",
    },
    scrollWrapper: {
      width: "100%",
      margin: isMobile ? "0.5rem 0" : "2rem 0",
      overflow: "hidden",
      position: "relative",
    },
    scrollContainer: {
      width: "100%",
      height: isMobile ? "60px" : "80px",
      display: "flex",
      alignItems: "center",
    },
    scrollContent: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      animation: isMobile ? `scrollAnimation 10s linear infinite` : "scrollAnimation 30s linear infinite",
    },
    scrollImage: {
      height: isMobile ? "40px" : "60px",
      width: "auto",
      padding: isMobile ? "0 1rem" : "0 1.5rem",
      objectFit: "contain",
      filter: "brightness(0.9) contrast(1.1)",
      transition: "transform 0.3s ease",
    },
    reviewsSection: {
      width: "100%",
      maxWidth: "1800px",
      padding: "2rem 1rem",
      margin: "2rem auto",
      position: "relative",
      zIndex: 1,
    },
    reviewsGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)", // Single column on mobile
      gap: isMobile ? "1rem" : "1.5rem",
      width: "100%",
    },
    reviewCard: {
      background: "rgba(20, 23, 31, 0.7)",
      backdropFilter: "blur(10px)",
      border: "1px solid rgba(88, 101, 242, 0.2)",
      borderRadius: "16px",
      padding: "1.5rem",
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      transition: "all 0.3s ease",
      position: "relative",
      overflow: "hidden",
    },
    reviewsHeader: {
      fontSize: isMobile ? "2.2rem" : "2.5rem",
      fontWeight: 800,
      color: "#ffffff",
      textAlign: "center",
      marginBottom: isMobile ? "0.5rem" : "2rem",
      textShadow: "0 0 20px rgba(88, 101, 242, 0.5)",
      letterSpacing: "2px",
      textTransform: "uppercase",
      background: "linear-gradient(45deg, #fff, #5865f2)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    footerContainer: {
      borderTop: "1px solid rgba(88, 101, 242, 0.2)",
      background: "rgba(20, 23, 31, 0.9)",
    },
    contactSection: {
      textAlign: "center",
      padding: "1.5rem 1rem 0.5rem",
      position: "relative",
      zIndex: 1,
    },
    contactTitle: {
      fontSize: "1.5rem",
      color: "#ffffff",
      marginBottom: "1rem",
      textShadow: "0 0 10px rgba(88, 101, 242, 0.3)",
    },
    contactInfo: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      alignItems: "center",
      justifyContent: "center",
    },
    contactItem: {
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      fontSize: "1rem",
      color: "#ffffff",
      textDecoration: "none",
      padding: "0.35rem 0.75rem",
      background: "rgba(88, 101, 242, 0.1)",
      borderRadius: "8px",
      border: "1px solid rgba(88, 101, 242, 0.2)",
      transition: "all 0.3s ease",
    },
    icon: {
      fontSize: "1.2rem",
    },
    footer: {
      width: "100%",
      textAlign: "center",
      padding: "1rem",
      color: "#8e9aff",
    },
  };

  // Create array of all car images
  const carImages = [tesla, civic, wrx, porsche911, porscheGT3, explorer, tahoe, astonmartin, stelvio, chrysler, bmwm4, ram, rolla];

  const reviews = [
    {
      name: "Korenna Sinn",
      review: "My cars were not only dusty and dirty, one was filthy from being parked under a tree. Nikita at BROT Auto Detailing washed and waxed my cars and they look shiny and new! Nikita is professional and detail oriented. He brings all of his own equipment and did a fantastic job. The cars look fabulous! The prices are reasonable and I will definitely use BROT again!",
    },
    {
      name: "Guy Hussussian",
      review: "I just had Nikita and Ali over to detail two cars.  They did an amazing job.  They have all the right equipment and went above and beyond what I expected.  Extremely nice and courteous.  Great attention to detail inside and out.  I highly recommend having them over before they go off to college.  Tell them Guy sent you!",
    },
    {
      name: "Debbie Gaspar",
      review: "I have been looking around for a little while for someone to come clean my car. It was filthy inside & out! I got a few estimates but had an issue with not really having access to water. Back duplex front parking. Right away Nikita said we do charge a little fee we can pick it up clean it then bring it back! That was music to my ears. Today he picked up my car and a couple of hours later brought it back looking like new. They really go out of their way to make sure the customer is happy. I am a very happy customer!",
    },
    {
      name: "Jo James",
      review: "I want to give a shout out to Nikita and his awesome auto detailing company that he has started. When I hired him, I did not know much about him, but I have to say that within a few hours that I spent with him, I can see where he is going.  He is not finished with the job until he feels it's perfect. I just think this is an outstanding young man. He loves what he does and it shows. I know if I could fast-forward 10 years, he is going to be a huge success in business and in life. I HIGHLY recommend hiring him.",
    },
  ];

  // Desktop Header Component
  const DesktopHeader = () => (
    <header style={styles.packagesHeader}>
      <div style={styles.headerContent}>
        <span style={styles.titlePart}>BROT AUTO DETAILING</span>
        <div style={styles.socialIcons}>
          <a href="https://www.instagram.com/brotdetailing" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" style={styles.socialIcon} />
          </a>
          <a href="https://www.tiktok.com/@brotdetailing" target="_blank" rel="noopener noreferrer">
            <img src={tiktokIcon} alt="TikTok" style={styles.socialIcon} />
          </a>
          <a href="https://nextdoor.com/pages/brot-auto-detailing-redwood-city-ca/?init_source=org_pages&utm_source=share&utm_campaign=1738206452300" target="_blank" rel="noopener noreferrer">
            <img src={nextdoorIcon} alt="Nextdoor" style={styles.nextdoorSocialIcon} />
          </a>
        </div>
      </div>
    </header>
  );

  // Mobile Header Component
  const MobileHeader = () => (
    <header style={styles.mobileHeader}>
      <div style={styles.mobileHeaderContent}>
        <div style={styles.mobileTitlePart}>BROT AUTO DETAILING</div>
        <div style={styles.mobileSocialIcons}>
          <button style={styles.mobileBackButton} onClick={() => setShowPackages("home")}>
            About Us
      </button>
          <a href="https://www.instagram.com/brotdetailing" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" style={styles.socialIcon} />
          </a>
          <a href="https://www.tiktok.com/@brotdetailing" target="_blank" rel="noopener noreferrer">
            <img src={tiktokIcon} alt="TikTok" style={styles.socialIcon} />
          </a>
          <a href="https://nextdoor.com/pages/brot-auto-detailing-redwood-city-ca/?init_source=org_pages&utm_source=share&utm_campaign=1738206452300" target="_blank" rel="noopener noreferrer">
            <img src={nextdoorIcon} alt="Nextdoor" style={styles.nextdoorSocialIcon} />
          </a>
        </div>
        </div>
      </header>
  );

  // Back Button Component
  const BackButton = () => {
    if (isMobile) {
      return null; // Don't render anything in mobile mode
    }

    return (
      <button style={styles.desktopBackButton} onClick={() => setShowPackages("home")}>
        <span>About Us</span>
      </button>
    );
  };

  return (
    <div style={styles.app}>
      <BackButton />

      {/* Conditional rendering of header based on screen size */}
      {isMobile ? <MobileHeader /> : <DesktopHeader />}

      <section style={styles.hero}>
        {/* Then carousel */}
        <div style={styles.scrollWrapper}>
          <div style={styles.scrollContainer}>
            <div style={styles.scrollContent}>
              {/* First set of images */}
              {carImages.map((car, index) => (
                <img key={`car-1-${index}`} src={car} alt="Luxury Car" style={styles.scrollImage} />
              ))}
              {/* Duplicate set for seamless loop */}
              {carImages.map((car, index) => (
                <img key={`car-2-${index}`} src={car} alt="Luxury Car" style={styles.scrollImage} />
              ))}
            </div>
          </div>
        </div>

        <div style={styles.packagesGrid}>
          <div 
            className="package-card exterior-package"
            style={styles.packageCard}
            onClick={() => {
              setSelectedPackage("exterior");
              setShowPackages("packageDetail");
            }}
          >
            <div
              style={{
                ...styles.packageContent,
                background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
            }}
          >
            <div className="package-header">
                <h2 style={styles.packageTitle}>
                  {isMobile ? "THE EXTERIOR PACKAGE" : "EXTERIOR PACKAGE"}
                </h2>
              </div>
              <div className="price">
                <span className="starting-at">Starting at</span>
                <span className="price-amount"> $90</span>
              </div>
            </div>
          </div>

          <div 
            className="package-card interior-package"
            style={styles.packageCard}
            onClick={() => {
              setSelectedPackage("interior");
              setShowPackages("packageDetail");
            }}
          >
            <div
              style={{
                ...styles.packageContent,
                background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
            }}
          >
            <div className="package-header">
                <h2 style={styles.packageTitle}>
                  {isMobile ? "THE INTERIOR PACKAGE" : "INTERIOR PACKAGE"}
                </h2>
              </div>
              <div className="price">
                <span className="starting-at">Starting at</span>
                <span className="price-amount"> $120</span>
              </div>
            </div>
          </div>

          <div 
            className="package-card basic-package"
            style={styles.packageCard}
            onClick={() => {
              setSelectedPackage("basic");
              setShowPackages("packageDetail");
            }}
          >
            <div
              style={{
                ...styles.packageContent,
                background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
            }}
          >
            <div className="package-header">
                <h2 style={styles.packageTitle}>
                  {isMobile ? "THE BASIC PACKAGE" : "BASIC PACKAGE"}
                </h2>
              </div>
              <div className="price">
                <span className="starting-at">Starting at</span>
                <span className="price-amount"> $179</span>
              </div>
            </div>
          </div>

          <div 
            className="package-card deluxe-package"
            style={styles.packageCard}
            onClick={() => {
              setSelectedPackage("deluxe");
              setShowPackages("packageDetail");
            }}
          >
            <div
              style={{
                ...styles.packageContent,
                background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
            }}
          >
            <div className="package-header">
                <h2 style={styles.packageTitle}>
                  {isMobile ? "THE DELUXE PACKAGE" : "DELUXE PACKAGE"}
                </h2>
              </div>
              <div className="price">
                <span className="starting-at">Starting at</span>
                <span className="price-amount"> $199</span>
              </div>
            </div>
          </div>

          <div 
            className="package-card maintenance-package"
            style={styles.packageCard}
            onClick={() => {
              setSelectedPackage("maintenance");
              setShowPackages("packageDetail");
            }}
          >
            <div
              style={{
                ...styles.packageContent,
                background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
            }}
          >
            <div className="package-header">
                <h2 style={styles.packageTitle}>
                  {isMobile ? "MAINTENANCE CUSTOMERS" : "MAINTENANCE"}
                </h2>
              </div>
              <div className="price">
                <span className="starting-at">Special Rates</span>
              </div>
            </div>
          </div>
        </div>

        <div style={styles.reviewsSection}>
          <h2 style={styles.reviewsHeader}>Client Reviews</h2>
          <div style={styles.reviewsGrid}>
            {reviews.map((review, index) => {
              const reviewLink = index === 0 ? "https://nextdoor.com/p/N3JJqqG_Y5Hp?utm_source=share&slp=&share_platform=10&extras=MTAyMDM1NDA4&utm_campaign=1738206014524" : index === 1 ? "https://nextdoor.com/p/THb3G_nNDxgj?utm_source=share&slp=&share_platform=10&extras=MTAyMDM1NDA4&utm_campaign=1738205711252" : index === 2 ? "https://nextdoor.com/p/wcwxCSfnkHsK?utm_source=share&slp=&share_platform=10&extras=MTAyMDM1NDA4&utm_campaign=1738206235850" : index === 3 ? "https://nextdoor.com/p/2GL7qJjtW4X_?utm_source=share&slp=&share_platform=10&extras=MTAyMDM1NDA4&utm_campaign=1738205797163" : null;

              return (
                <div key={index} style={styles.reviewCard}>
                  {reviewLink ? (
                    <a href={reviewLink} target="_blank" rel="noopener noreferrer" className="review-card-link">
                      <div className="review-name">
                        <span className="hex-icon">⬡</span>
                        {review.name}
                        <img src={nextdoorIcon} alt="Nextdoor" className={`nextdoor-icon-${index + 1}`} />
                      </div>
                      <div className="review-text">"{review.review}"</div>
                    </a>
                  ) : (
                    <div className="review-name">
                      <span className="hex-icon">⬡</span>
                      {review.name}
                      <img src={nextdoorIcon} alt="Nextdoor" className={`nextdoor-icon-${index + 1}`} />
                    </div>
                  )}
                    </div>
              );
            })}
              </div>
            </div>
      </section>

      {!isMobile && (
        <div style={styles.footerContainer}>
          <div style={styles.contactSection}>
            <h2 style={styles.contactTitle}>CONTACT US</h2>
            <div style={styles.contactInfo}>
              <a href="tel:+16504544583" style={styles.contactItem}>
                <span style={styles.icon}>📞</span>
                  (650) 454-4583
                </a>
              <a href="mailto:brotdetailing@gmail.com" style={styles.contactItem}>
                <span style={styles.icon}>📧</span>
                brotdetailing@gmail.com
                </a>
              </div>
            </div>
          <p style={styles.footer}>&copy; 2025 BROT Auto Detailing</p>
        </div>
        )}

      {isMobile && (
        <div style={{ textAlign: "center", margin: "1rem" }}>
          <label htmlFor="speedControl">Animation Speed (seconds): </label>
          <input
            id="speedControl"
            type="range"
            min="10"
            max="60"
            value={animationSpeed}
            onChange={handleSpeedChange}
            style={{ marginLeft: "10px" }}
          />
          <span>{animationSpeed}s</span>
        </div>
      )}
    </div>
  );
}

export default Packages; 
